import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
	selector: '[customScrollbar]'
})
export class CustomScrollbarDirective {

	@Input() styleType: string; // default, dark, light
	private El: ElementRef;
	constructor(el: ElementRef) {
		this.El = el;
	}

	ngOnInit() {

		let stylesheet = `
			::-webkit-scrollbar {
				width: 10px;
			}
			::-webkit-scrollbar-track {
				background: var(--ion-color-light-tint);
			}
			::-webkit-scrollbar-thumb {
				border-radius: 0;
				background: var(--color-scrollbar-gradient);
				border: none;
			}
			::-webkit-scrollbar-thumb:hover {
			}
		`;
		const stylesheetlight = `
			::-webkit-scrollbar {
				width: 10px;
			}
			::-webkit-scrollbar-track {
				background: var(--ion-color-light-tint);
			}
			::-webkit-scrollbar-thumb {
				border-radius: 0;
				background: var(--color-scrollbar-gradient-light);
				border: none;
			}
			::-webkit-scrollbar-thumb:hover {
			}
		`;

		const stylesheetdark = `
			::-webkit-scrollbar {
				width: 10px;
			}
			::-webkit-scrollbar-track {
				background: var(--color-text-grey);
			}
			::-webkit-scrollbar-thumb {
				border-radius: 0;
				background: var(--color-scrollbar-gradient-light);
				border: none;
			}
			::-webkit-scrollbar-thumb:hover {
			}
		`;

		const styleElmt = this.El.nativeElement.shadowRoot.querySelector('style');

		switch (this.styleType) {
			case 'light':
				stylesheet = stylesheetlight;
				break;
			case 'dark':
				stylesheet = stylesheetdark;
				break;

			default:

				break;
		}

		if (styleElmt) {
			styleElmt.append(stylesheet);
		} else {
			const barStyle = document.createElement('style');
			barStyle.append(stylesheet);
			this.El.nativeElement.shadowRoot.appendChild(barStyle);
		}

	}
}
